import React from "react";
import { ContainerReports, ContainerIframe } from "./ReportsContainer.styled";

const ReportsContainer = () => {
  const iframe =
    '<iframe src="https://app.powerbi.com/reportEmbed?reportId=80605ca5-11cf-4465-91b3-a157e56b56be&autoAuth=true&ctid=638fcbaf-ba4c-43e1-adae-5475c970fe10&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLW5vcnRoLWV1cm9wZS1mLXByaW1hcnktcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D" width="1000px" height="610px"></iframe>';
  return (
    <ContainerReports>
      <ContainerIframe
        contentEditable="true"
        dangerouslySetInnerHTML={{ __html: iframe }}
      ></ContainerIframe>
    </ContainerReports>
  );
};

export default ReportsContainer;
